import { warningColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const addNewServiceStyle = (theme) => ({
	addNewServiceWrapper: {
		maxWidth: '100%',
	},
	contentWrapper: {
		backgroundColor: whiteColor,
		padding: 32,
		marginTop:'20px',
		borderRadius: 8,
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 10,
			paddingRight: 10,
		},
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingTop: 20,
		'& button': {
			marginTop: 0,
			marginBottom: 0,
		},
	},
	helperText: {
		color: `${warningColor[0]} !important`
	}
});

export default addNewServiceStyle;
